exports = module.exports = require("../../../../../../legacy/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img[data-v-42c6452c] {\n  width: 40px;\n}\nhr[data-v-42c6452c] {\n  margin: 10px 0;\n}", ""]);

// exports
